let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bSySW")).then(() => parcelRequire('Cam0x'));